import React  from 'react'
 
import DeliverableList from './DeliverableList';
export default function BuildingMaintenanceList() {
    return <DeliverableList category="BM"/>
}
